import * as React from 'react';

function SvgCartTick() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7286 5.37198C13.9009 5.20259 14.1779 5.20494 14.3473 5.37724C14.5167 5.54954 14.5144 5.82654 14.3421 5.99594L7.17265 13.0445C7.00247 13.2119 6.72958 13.2119 6.55933 13.0447L3.49125 10.0305C3.31888 9.86117 3.31643 9.58417 3.48576 9.41181C3.65509 9.23945 3.93209 9.23699 4.10446 9.40632L6.86582 12.1192L13.7286 5.37198Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgCartTick;
